<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_button_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

@if (itemField) {
    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div class="form-row">
                <div class="form-group mb-20" [class.has-error]="saveDisablePredicate">
                    <label class="col-xs-12">
                        {{ "control_text" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <input class="form-control" [formField]="itemField.label" />
                        @if (saveDisablePredicate) {
                            <span class="help-block small">
                                {{ "control_errors_required" | translate }}
                            </span>
                        }
                    </div>
                </div>
                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ LINK_TYPE_NAME[itemValue.link.type] | translate }}
                    </label>
                    <div class="col-xs-12 input-group">
                        <div class="input-group-btn type-dropdown" dropdown>
                            <button dropdownToggle type="button" class="btn btn-default type-dropdown-toggle">
                                <img
                                    class="element-icon mr-10"
                                    src="./assets/img/websites/forms-icons/lpc-f-{{ itemValue.link.type }}-icon.svg"
                                    alt="url-icon"
                                />
                                <span class="caret"></span>
                            </button>
                            <ul class="dropdown-menu" *dropdownMenu>
                                @for (option of LINK_TYPES; track option) {
                                    <li
                                        [class.selected]="option.type === itemValue.link.type"
                                        (click)="setLinkType(option)"
                                    >
                                        <a>
                                            <span class="dropdown-icon mr-10">
                                                <img
                                                    src="./assets/img/websites/forms-icons/lpc-f-{{
                                                        option.type
                                                    }}-icon.svg"
                                                    [alt]="option.type"
                                                />
                                            </span>
                                            {{ option.name | translate }}
                                        </a>
                                    </li>
                                }
                            </ul>
                        </div>
                        <input
                            class="form-control"
                            [placeholder]="BUTTON_LINK_TYPE_PLACEHOLDER[itemValue.link.type]"
                            [formField]="itemField.link.url"
                        />
                    </div>
                    <div class="col-xs-12">
                        <label class="checkbox-inline">
                            <input
                                type="checkbox"
                                [checked]="itemValue.isTargetBlank"
                                (change)="toggleTargetBlank($any($event.target).checked)"
                            />
                            {{ "control_target" | translate }}
                        </label>
                    </div>
                    @if (itemValue.link.url?.includes("t.me")) {
                        <div class="col-xs-12">
                            <label class="checkbox-inline">
                                <input
                                    type="checkbox"
                                    [checked]="itemValue.preventLinkConverting"
                                    (change)="togglePreventLinkConverting($any($event.target).checked)"
                                />
                                {{ "prevent_link_wrapping" | translate }}
                            </label>
                        </div>
                    }
                </div>
                <div class="form-group">
                    <label class="col-xs-12">
                        {{ "control_style" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <select class="form-control" (change)="setStyleType($event)">
                            <option
                                [value]="EButtonStyleType.primary"
                                [selected]="itemValue.styleType === EButtonStyleType.primary"
                            >
                                {{ "control_appearance_primary" | translate }}
                            </option>
                            <option
                                [value]="EButtonStyleType.secondary"
                                [selected]="itemValue.styleType === EButtonStyleType.secondary"
                            >
                                {{ "control_appearance_secondary" | translate }}
                            </option>
                            <option
                                [value]="EButtonStyleType.custom"
                                [selected]="itemValue.styleType === EButtonStyleType.custom"
                            >
                                {{ "control_appearance_custom" | translate }}
                            </option>
                        </select>
                    </div>
                    <div class="col-xs-6">
                        <div class="btn-group d-flex">
                            <sp-radio-group
                                [selected]="itemValue.size"
                                [type]="ERadioGroupType.size"
                                (changeSelectedEvent)="setSize($event)"
                            />
                        </div>
                    </div>
                </div>
                @if (itemValue.styleType === EButtonStyleType.custom) {
                    <web-custom-button
                        class="mb-20"
                        style="display: block"
                        [parentBase]="$any(itemValue.buttonBase)"
                        [parentHover]="$any(itemValue.buttonHover)"
                        [isIndependentCorners]="itemValue.isIndependentCorners"
                        [radiusSettings]="$any(itemValue.advancedRadius)"
                        [advancedBorderSettings]="$any(itemValue.advancedBorderSettings)"
                        [isAdvancedRadius]="true"
                        (valueChangeEvent)="customButtonChangeHandler($event)"
                    />
                }
                @if (!isSpecificWidget() && !isZeroWidget()) {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_width" | translate }}
                        </label>
                        <div
                            [class.col-xs-7]="itemValue.widthType === EButtonWidthType.fixed"
                            [class.col-xs-12]="itemValue.widthType !== EButtonWidthType.fixed"
                        >
                            <select class="form-control" (change)="setWidthType($event)">
                                <option
                                    [value]="EButtonWidthType.auto"
                                    [selected]="itemValue.widthType === EButtonWidthType.auto"
                                >
                                    {{ "control_appearance_auto" | translate }}
                                </option>
                                <option
                                    [value]="EButtonWidthType.full"
                                    [selected]="itemValue.widthType === EButtonWidthType.full"
                                >
                                    {{ "control_appearance_full" | translate }}
                                </option>
                                <option
                                    [value]="EButtonWidthType.fixed"
                                    [selected]="itemValue.widthType === EButtonWidthType.fixed"
                                >
                                    {{ "control_appearance_fixed" | translate }}
                                </option>
                            </select>
                        </div>
                        @if (itemValue.widthType === EButtonWidthType.fixed) {
                            <div class="col-xs-5">
                                <sp-input-num
                                    suffixText="px"
                                    [min]="CSS_RESTRICTIONS.MIN_WIDTH_BUTTON_VALUE"
                                    [value]="itemValue.widthValue"
                                    (valueChange)="setWidthValue($event)"
                                />
                            </div>
                        }
                    </div>
                }
                <div>
                    <sp-button-icon
                        [buttonIcon]="$any(itemValue.buttonIcon)"
                        (valueChangeEvent)="buttonIconChangeHandler($event)"
                    />
                </div>
                <div class="mb-15">
                    <sp-button-additional-effects-settings
                        [additionalEffects]="$any(itemValue.additionalEffects)"
                        (valueChangeEvent)="additionalEffectsChangeHandler($event)"
                    />
                </div>
                <div class="form-group" [class.mb-20]="!itemValue.isShadow" [class.mb-10]="itemValue.isShadow">
                    <label class="col-xs-9 control-label">
                        {{ "control_shadow" | translate }}
                    </label>
                    <div class="col-xs-3 text-right">
                        <sp-switch [active]="itemValue.isShadow" (toggleActiveEvent)="setShadow($event)" />
                    </div>
                </div>
                @if (itemValue.isShadow) {
                    <sp-shadow-settings-signal-legacy
                        [shadowSettings]="itemValue.shadowSettings"
                        (valueChangeEvent)="setShadowSettings($event)"
                    />
                }
            </div>
            <a
                class="dotted mt-20 mb-20 d-inline-block analytic-link"
                (click)="setSettingsView()"
                [class.active]="isShowAnalyticsSettings || isEnabledAnalytic"
            >
                {{ "analytics_form_settings" | translate }}
                <span class="caret"></span>
            </a>
            @if (isShowAnalyticsSettings || isEnabledAnalytic) {
                <web-analytics-settings-signal-legacy
                    [settings]="itemValue.analyticsSettings ?? null"
                    [showFullSettings]="false"
                    [pixelAnalyticType]="EPixelTypes.lead"
                    (valueChangeEvent)="setAnalyticsSettings($event)"
                    (cancelEvent)="setSettingsView()"
                />
            }
            <div class="mt-20">
                <web-custom-id [displayId]="itemValue.elementId" (valueChangeEvent)="setNewElementId($event)" />
            </div>
        </div>
    </div>
}

<web-settings-footer [isSaveDisabled]="saveDisablePredicate" (saveEvent)="onSave()" (cancelEvent)="onReset()" />
